import React from "react"
import Button from "../button"
import * as Icon from "react-feather"

export default () => (
  <div className="event-detail container">
    <header className="event-detail__header">
      <div className="event-detail__image"></div>
      <div className="event-detail__details card">
        <div className="event-detail__details-section">
          <div>
            <p className="event-detail__tag event-detail__tag--type">
              Event type
            </p>
          </div>
          <p className="event-detail__tag event-detail__tag--date">
            MAR 27
            <Icon.ChevronsRight className="event-detail__tag--date__icon" />
            APR 27
          </p>
        </div>
        <div className="event-detail__details-section">
          <div>
            <p className="event-detail__title">Event title</p>
            <p className="event-detail__venue">Event venue</p>
          </div>
          <div className="event-detail__flag">
            <Icon.Flag className="event-detail__flag-icon" />
          </div>
        </div>
        <div className="event-detail__details-section">
          <div className="event-detail__address">
            <address>
              <p>
                EF Education First
                <br />
                Chelsea, London
                <br />
                SW3 5RL
              </p>
            </address>
          </div>
        </div>
      </div>
    </header>
    <div className="event-detail__body">
      <div className="event-detail__content card card--pd-sm">
        <p className="event-detail__content-heading">Description</p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
      <div className="event-detail__calendar card card--pd-sm">
        <p id="calendar">Calendar goes here...</p>
        <div className="fake-calendar"></div>
      </div>
      <footer className="event-detail__footer">
        <Button
          href="#calendar"
          text="Register for event"
          iconName="ArrowDown"
          className="btn--color event-detail__footer-btn"
        />
      </footer>
    </div>
  </div>
)
